import { CustomInjector, ModelOptionsLoaderService, TextModel } from '@evorait/pace-core';

export class SmartlockerTransferModel {
    public awbPackageNumber: TextModel;

    public constructor(public deliveryAwbPackageNumber: string) {
        const injector = CustomInjector.getInjector();
        const modelOptionsLoader = injector.get(ModelOptionsLoaderService);

        this.awbPackageNumber = new TextModel('AwbPackageNumber');
        modelOptionsLoader.load(this.awbPackageNumber, 'Smartlocker', 'AwbPackageNumber');
        this.awbPackageNumber.options = {
            ...this.awbPackageNumber.options,
            pattern: this.deliveryAwbPackageNumber,
        };
    }

    public isMatchingAwbPackageNumber(): boolean {
        return this.awbPackageNumber.value === this.deliveryAwbPackageNumber;
    }
}
